import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { trackVirtualPageView } from "../../utils/analytics"
import Patientinfo from "../../views/welcomevisits/patientinfo"
import Patientform from "../../views/welcomevisits/patientform"
import Corticacenter from "../../views/welcomevisits/corticacenter"
import Caregiverinfo from "../../views/welcomevisits/caregiver"
import Insurance from "../../views/welcomevisits/insurance"
import InsurancePlan from "../../views/welcomevisits/insurancePlan"
import ConsentPage from "views/welcomevisits/consentpage"

const pathToStep = {
  "": 1,
  "patient-info": 2,
  "patient-form-info": 3,
  "cortica-center": 4,
  "caregiver-info": 5,
  "insurance-info": 6,
  "insurance-plan-info": 7,
  "start-scheduling": 7,
  "schedule-booking": 7,
  "confirm-booking": 7,
  "booking-confirmed": 7,
}

const stepToPath = {
  1: "",
  2: "patient-info",
  3: "patient-form-info",
  4: "cortica-center",
  5: "caregiver-info",
  6: "insurance-info",
  7: "insurance-plan-info",
}

const insurancePlanSubSteps = [
  "start-scheduling",
  "schedule-booking",
  "confirm-booking",
  "booking-confirmed",
]

const getCurrentPath = (pathname = "") => {
  const segments = pathname.split("/").filter(Boolean)
  return segments[segments.length - 1] || ""
}

const Welcomevisits = ({ location }) => {
  const getInitialStep = () => {
    if (typeof window !== "undefined" && location?.pathname) {
      const currentPath = getCurrentPath(location.pathname)

      if (insurancePlanSubSteps.includes(currentPath)) {
        console.log("[WelcomeVisits] Substep on refresh, reset to step 7")
        return 7
      }

      if (currentPath in pathToStep) {
        return pathToStep[currentPath]
      }

      return 1
    }
    return 1
  }

  const [step, setstep] = useState(getInitialStep)

  useEffect(() => {
    if (typeof window !== "undefined" && location) {
      const currentPath = getCurrentPath(location.pathname)
      const computedStep =
        currentPath in pathToStep
          ? pathToStep[currentPath]
          : insurancePlanSubSteps.includes(currentPath)
          ? 7
          : 1

      if (computedStep !== step) {
        setstep(computedStep)
      }
    }
  }, [location, location?.pathname, step])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const newPath = stepToPath[step] || ""
      const newUrl = `/welcomevisit${newPath ? `/${newPath}` : ""}`

      const currentPathname = window.location.pathname
      const currentLastSegment = getCurrentPath(currentPathname)

      if (insurancePlanSubSteps.includes(currentLastSegment)) {
        if (step !== 7) {
          const fallbackUrl = "/welcomevisit"
          window.history.replaceState({ step }, "", fallbackUrl)
          console.log("[WelcomeVisits] Forced URL reset to", fallbackUrl)
        } else {
          console.log(
            "[WelcomeVisits] Skipping URL sync, in valid insurance substep:",
            currentLastSegment
          )
        }
        return
      }

      if (currentPathname !== newUrl) {
        window.history.replaceState({ step }, "", newUrl)
        trackVirtualPageView()
        console.log("[WelcomeVisits] URL synced to", newUrl)
      }
    }
  }, [step])

  const nextStep = () => setstep(prev => prev + 1)
  const prevStep = () => setstep(prev => prev - 1)

  const [analyticsPayload, setAnalyticsPayload] = useState({
    campaign: "",
    campaignStacking: "",
    gaclientid: "",
    gclid: "",
    medium: "",
    source: "",
  })
  const [user, setUser] = useState({
    address1: "",
    address2: "",
    birthdate: "",
    city: "",
    country: "USA",
    gender: "",
    lastName: "",
    name: "",
    state: "",
    zipCode: "",
    newdatebirth: "",
  })
  const [pationinfo, setPationinfo] = useState({
    previously_diagnosed: "true",
    seeking_diagnoses: "true",
    seeking_evaluation: "true",
  })
  const [careinfo] = useState({
    careinformation: "",
    emergency_contact: "true",
    legal_guardian: "true",
  })
  const [findAFacilityuser, setfindAFacility] = useState({
    findAFacility: "",
    leadSource: "",
    leadSourceDetail: "",
  })
  const [careuser, setcareUser] = useState({
    address1: "",
    address2: "",
    city: "",
    country: "USA",
    check: false,
    emailAddress: "",
    lastName: "",
    name: "",
    phoneNumber: "",
    primary_caregiver: "true",
    state: "",
    zipCode: "",
  })
  const [insuranceuser, setinsuranceUser] = useState({
    address1: "",
    address2: "",
    checkbox: "",
    city: "",
    check: false,
    country: "USA",
    emailAddress: "",
    lastName: "",
    name: "",
    phoneNumber: "",
    state: "",
    zipCode: "",
  })
  const [insuranceplan, setinsuranceplan] = useState({
    insurance_name: "",
    insurance_phone: "",
    member_number: "",
    group_number: "",
    plan_coverage: "PPO",
    plan_name: "",
  })

  switch (step) {
    case 1:
      return (
        <div className="App">
          <ConsentPage nextStep={nextStep} />
        </div>
      )
    case 2:
      return (
        <div className="App">
          <Patientinfo
            nextStep={nextStep}
            setUser={setPationinfo}
            user={pationinfo}
          />
        </div>
      )
    case 3:
      return (
        <div className="App">
          <Patientform
            analyticsPayload={analyticsPayload}
            nextStep={nextStep}
            prevStep={prevStep}
            setAnalyticsPayload={setAnalyticsPayload}
            setUser={setUser}
            user={user}
          />
        </div>
      )
    case 4:
      return (
        <div className="App">
          <Corticacenter
            nextStep={nextStep}
            prevStep={prevStep}
            setUser={setfindAFacility}
            user={findAFacilityuser}
          />
        </div>
      )
    case 5:
      return (
        <div className="App">
          <Caregiverinfo
            nextStep={nextStep}
            pationuser={user}
            prevStep={prevStep}
            setUser={setcareUser}
            user={careuser}
          />
        </div>
      )
    case 6:
      return (
        <div className="App">
          <Insurance
            careuser={careuser}
            nextStep={nextStep}
            pationuser={user}
            prevStep={prevStep}
            setUser={setinsuranceUser}
            user={insuranceuser}
          />
        </div>
      )
    case 7:
      return (
        <div className="App">
          <InsurancePlan
            apiData={{
              analyticsPayload: analyticsPayload,
              careinfo: careinfo,
              careuser: careuser,
              findAFacilityuser: findAFacilityuser,
              insuranceplan: insuranceplan,
              insuranceuser: insuranceuser,
              pationinfo: pationinfo,
              user: user,
            }}
            nextStep={nextStep}
            prevStep={prevStep}
            setUser={setinsuranceplan}
            user={insuranceplan}
          />
        </div>
      )
    case 8:
      return (
        <div className="App">
          <h1>hello</h1>
        </div>
      )
    // default case to show nothing
    default:
      return <div className="App"></div>
  }
}

Welcomevisits.propTypes = {
  location: PropTypes.object,
}

export default Welcomevisits
